module.exports = __webpack_public_path__ + "media/images/shop/box_dimensions-a9cad7c45290885ff1615e5736a0e462.png";